const initialState = {
  id: null,
  name: "",
  shortName: "",
  address: "",
  state: "",
  city: "",
  zip: "",
  phone: "",
  fax: "",
  taxId: "",
};

// Client Information Reducer
const clientReducer = (state = initialState, action) => {
  switch (action.type) {
    case "SET_CLIENT":
      return {
        ...state,
        ...action.payload,
      };
    case "CLEAR_CLIENT":
      return {
        ...state,
        id: null,
        name: "",
        shortName: "",
        address: "",
        state: "",
        city: "",
        zip: "",
        phone: "",
        fax: "",
        taxId: "",
      };
    default:
      return state;
  }
};

export default clientReducer;
